export default {
  serverUrl: 'https://webatariapi.tudorhutu.ro/api',
};
